import { StoredValueChart } from "../../../d3charts/storedvalue/StoredValue";

export const StoredValueChartConfig = ({
  data,
  width,
  height,
  config,
  lRef,
}) => {
  return (
    <StoredValueChart
      data={data}
      width={width}
      height={height}
      config={config}
      lRef={lRef}
    />
  );
};
